<template>
    <div class="ui-list">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "ui-list"
};
</script>

<style lang="scss" scoped>
.ui-list {
    margin: auto;
    padding: 0 var(--padding-50) var(--padding);
    display: flex;
    flex-wrap: wrap;
    min-height: 20rem;

    .post-item {
        width: 33.33%;
    }
}

@media only screen and (max-width: 767px) {
    .ui-list {
        // width: 100%;

        .post-item {
            width: 80%;
            margin: var(--padding-50) auto;
        }
    }
}
</style>
